import type { AbilityScores, Race, Subrace } from '@character-creator/types';

/**
 * Calculate racial ability score bonuses from race and optional subrace
 */
export function calculateRacialBonuses(
  race: Race | null | undefined,
  subrace?: Subrace | null
): Partial<AbilityScores> {
  const bonuses: Partial<AbilityScores> = {};

  if (race) {
    for (const bonus of race.abilityBonuses) {
      bonuses[bonus.ability] = (bonuses[bonus.ability] || 0) + bonus.bonus;
    }
  }

  if (subrace) {
    for (const bonus of subrace.abilityBonuses) {
      bonuses[bonus.ability] = (bonuses[bonus.ability] || 0) + bonus.bonus;
    }
  }

  return bonuses;
}

/**
 * Apply racial bonuses to base ability scores
 */
export function applyRacialBonuses(
  baseScores: AbilityScores,
  racialBonuses: Partial<AbilityScores>
): AbilityScores {
  return {
    strength: baseScores.strength + (racialBonuses.strength || 0),
    dexterity: baseScores.dexterity + (racialBonuses.dexterity || 0),
    constitution: baseScores.constitution + (racialBonuses.constitution || 0),
    intelligence: baseScores.intelligence + (racialBonuses.intelligence || 0),
    wisdom: baseScores.wisdom + (racialBonuses.wisdom || 0),
    charisma: baseScores.charisma + (racialBonuses.charisma || 0),
  };
}
